import { createSlice } from '@reduxjs/toolkit'

const initialSubscriptionPlanState = {
  subscriptionPlan: null,
  subscriptionPlans: null,
  subscriptionPlansDropdown: null,
  companies: [],
  freeAndPaidPlanList: [],
  selectedPlanId: null,
  replacePlanId: null,
  countriesDropdown:[]
}

export const SubscriptionPlanSlices = createSlice({
  name: 'subscriptionPlans',
  initialState: initialSubscriptionPlanState,
  reducers: {
    subscriptionPlans: (state, action) => {
      state.subscriptionPlans = action.payload.subscription_plans
    },
    subscriptionPlan: (state, action) => {
      state.subscriptionPlan = action.payload.subscription_plan
      state.companies = action.payload?.companies
    },
    subscriptionPlanList: (state, action) => {
      state.subscriptionPlansDropdown = action.payload.subscription_plans
    },
    freeAndPaidPlanList: (state, action) => {
      state.freeAndPaidPlanList = action.payload.subscription_plans
    },
    setSelectedPlan: (state, action) => {
      state.selectedPlanId = action.payload;
    },
    setReplacePlan: (state, action) => {
      state.replacePlanId = action.payload;
    },
    countriesList: (state, action) => {
      state.countriesDropdown = action.payload.countries
    },
  },
})